import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=6a12046b&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12046b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a12046b')) {
      api.createRecord('6a12046b', component.options)
    } else {
      api.reload('6a12046b', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=6a12046b&scoped=true", function () {
      api.rerender('6a12046b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/notifications/Notification.vue"
export default component.exports